export default __webpack_public_path__ + "static/media/loading nft.4d50662d.png";